export class BeneficiariesDataToImport {
  productItemId: number;
  beneficiariesNamesFile: string;
}
